import React, {useState} from 'react';
import axios from 'axios';
import clientConfig from '../../../../client-config';
import { Checkbox, Form, Button, Typography, Row, Col, Divider, Switch } from 'antd';
const { Text } = Typography;
const CheckboxGroup = Checkbox.Group;
var defaults = [];
var initValues = {
    appareils: defaults
};
const EditLeadAppareils = ({ dataLead, handleOk, handleCancel, confirmLoading }) => { 
    const [switched, setSwitched] = useState(false);
    const [disabled, setDisabled] = useState(false);
    let vf = [];
    const uappareils ={
        Id: dataLead[0].Id,
        appareils: dataLead[0].appareils,
    }
    function onChange(checkedvalues) {
        return vf.push(checkedvalues);
    }
    const onSwitch = () => {
        setSwitched(!switched);
        setDisabled(!disabled);
    }
    const submitForm = (e) => {
        if (switched === true) {
            uappareils.appareils = JSON.stringify(defaults);
        }
        else if (switched === false){
            uappareils.appareils = JSON.stringify(e.appareils);
        }
        onChange(e);
        const wordPressSiteUrl = clientConfig.siteUrl;
        axios.post(`${wordPressSiteUrl}/wp-json/leads/uappareils`, uappareils)
          .then()
          .catch(err => {console.log(err.response.data.message)})
        handleOk();
    }
    return(
        <Form onFinish={submitForm} initialValues={initValues} >
        <Form.Item
          name="appareils"
          value={uappareils.appareils}
          onChange={(e) => {uappareils.appareils = e.target.value }}
        >
          <CheckboxGroup
            className="boxe"
            style={{ width: '100%' }}
            onChange={onChange}
          >
              <Row gutter={[16, 16]}>
                <Col span={24}>
                  <Checkbox value="Mixeur" disabled={disabled}><Text>Mixeur</Text></Checkbox>
                </Col>
                <Col span={24}>
                  <Checkbox value="Four" disabled={disabled}><Text>Four</Text></Checkbox>
                </Col>
                <Col span={24}>
                  <Checkbox value="Micro onde" disabled={disabled}><Text>Micro onde</Text></Checkbox>
                </Col>
                <Col span={24}>
                  <Checkbox value="Cuisinière" disabled={disabled}><Text>Cuisinière</Text></Checkbox>
                </Col>
                <Col span={24}>
                  <Checkbox value="Pot instantané" disabled={disabled}><Text>Pot instantané</Text></Checkbox>
                </Col>
              </Row>
          </CheckboxGroup>
        </Form.Item>
        
        <Row justify="end">
          <Col xs={{ span: 9 }} sm={{ span: 9 }} md={{ span: 9 }} lg={{ span: 9 }} xl={{ span: 9 }}>
            <Text style={{lineHeight:2.3}} >Aucune de ces réponses </Text>
          </Col>
          <Col span={2}>
            <Form.Item layout="inline" valuePropName="checked" name="firstSwitch">
              <Switch checked={switched} onChange={onSwitch} />
            </Form.Item>
          </Col>
        </Row>
        <Divider />
        <Row justify="end">
          <Col xs={{ span: 4, pull: 3 }} sm={{ span: 4, pull: 3 }} md={{ span: 4, pull: 3 }}>      
            <Form.Item>
              <Button key="back" onClick={handleCancel}>
                Annuler
              </Button>
            </Form.Item>
          </Col>
          <Col xs={{ span: 4, pull: 2 }} sm={{ span: 4, pull: 2 }} md={{ span: 4, pull: 2 }}>      
            <Form.Item>
              <Button type="primary" htmlType="submit" loading={confirmLoading} >
                Enregistrer
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    )
}
export default EditLeadAppareils;